<template>
    <div class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full bg-gray-400 bg-opacity-50 z-50" v-if="newloaded">
  <div class="bg-white rounded-xl w-11/12 sm:w-2/3 md:w-1/2 lg:w-1/3 xl:w-1/4 p-4">
    <div class="flex flex-col items-start space-y-4">
      <div class="w-full">
        <div class="text-gray-900 font-medium text-lg text-center sm:text-left"><strong>Synchronization of Books</strong></div>
      </div>

      <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-500 p-3 sm:p-4 m-2 sm:m-4 text-sm sm:text-base" role="alert">
        <p class="text-left" v-if="preload_books.length > 0 || newload_data.length > 0">These are your previous books across various <strong>Cloudstaff Tap Platforms (Mobile / Web)</strong>. Please select the book/s that you want to add in this session.</p>
        <p class="text-left" v-else>Welcome! You don't have any books to synchronize yet. You can start using the platform and create or import books when ready.</p>
      </div>

      <div v-if="preload_books.length > 0 || newload_data.length > 0" class="flex flex-col items-start h-40 w-full overflow-y-auto space-y-2">
        <div class="flex justify-start pl-5" v-for="preloaded in preload_books" :key="preloaded.key">
          <div>
            <div class="form-check">
              <input class="checkbox checkbox-primary" type="checkbox" value="" id="1" disabled checked>
              <label class="form-check-label inline-block text-gray-800" for="1">
                &emsp14; {{preloaded}} <small>(Auto)</small>
              </label>
            </div>
          </div>
        </div>
        <div class="flex justify-start pl-5" v-for="newloaded in newload_data" :key="newloaded.key">
          <div>
            <div class="form-check">
              <input class="checkbox checkbox-primary" type="checkbox" :value="newloaded" :id="newloaded" v-model="checkedBooks">
              <label class="form-check-label inline-block text-gray-800 cursor-pointer" :for="newloaded">
                &emsp14; {{newloaded}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex flex-col items-center justify-center h-40 w-full">
        <p class="text-gray-400 text-center">No books available to synchronize</p>
      </div>
      
      <hr class="my-4" v-if="preload_books.length > 0 || newload_data.length > 0">

      <div v-if="preload_books.length > 0 || newload_data.length > 0" class="grid grid-cols-7 gap-4 w-full sm:grid-cols-5">
        <div class="col-span-5 sm:col-start-1 sm:col-end-4">
          <div class="form-check float-left ml-3 sm:ml-5">
            <input class="checkbox checkbox-primary" type="checkbox" id="allcheck" :true-value="0" :false-value="1" v-model="selectAllBooks" @click="select_all_books">
            <label class="form-check-label inline-block text-gray-800 cursor-pointer" for="allcheck">
              &emsp14;Select All
            </label>
          </div>
        </div>
        <div class="col-span-2 sm:col-end-8 flex justify-end">
          <button @click="book_sync" class="bg-blue-500 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-xl" :disabled="syncButton !== 'Continue'">
            <small>{{syncButton}}</small>
          </button>
        </div>
      </div>
      <div v-else class="flex justify-end w-full">
        <button @click="skipBookSync" class="bg-blue-500 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-xl">
          <small>Continue</small>
        </button>
      </div>
    </div>
  </div>
</div>



<div v-if="this.vh1Value == 28 && this.vh2Value == 38" class="p-12">

  <div v-if="isMobile">
    <div class="flex justify-center"><img src="@/assets/rotatedevice.jpg" class=""></div>
    <h3>Kindly switch your device to landscape mode, or if you're still encountering this message, please use the CSTap mobile application.</h3>
  </div>

  <div v-else>
    <div class="flex justify-center"><img src="@/assets/maximizescreensize.png" class="h-28"></div>
    <h3>Kindly maximize your [MS Teams] or [Browser] and make sure your screen resolution is at least “1280x720” to fully support the CS Tap Web application.</h3>
  </div>
  
</div>
<div v-else class="card lg:card-side blue-card w-full lg:mr-12 rounded-3xl lg:ml-12 md:h-90vh lg:h-90vh z-1 mb-4">
    <div class="grid lg:grid-cols-1 md:grid-cols-2 grid-cols-1 gap-4 lg:px-6 md:px-4 py-6 w-full">
      <div class="flex flex-col">
           <!-- Header Content -->
        <div class="mb-2 h-30">
          <div class="tabs tabs-boxed blue-card rounded-xl ">
            <div v-for="book in this.$store.getters.books" :key="book.key">
                 <a class="tab" 
                    v-bind:class="{ 'bg-gray-300 font-bold text-blue-600 rounded-xl': selected_book === book }" 
                    v-if="this.$store.getters.active_books.includes(book)"
                    v-on:click="selectBook(book)">
                  <span >{{book}}</span>
                </a> 
            </div>
          </div>
        </div>
        <div class="">
            <div class="w-full border-t border-gray-300"></div>
        </div>
        <!-- Title, Description and Search Bar -->
        <div class="m-2 h-30">
          <div class="sm:flex sm:justify-between mb-2 items-start sm:items-center">
            
            <!-- LEFT SIDE: Title + Description -->
            <div class="text-left max-w-[1500px]">
              <!-- Title -->
              <p v-if="!vuexLoaderTrigger" class="text-xl font-bold flex items-center gap-2">
                <span v-if="withUpdates.includes(selected_book)">
                  {{ selected_book }}
                  <a 
                    @click="selectBook(selected_book)" 
                    :title="'Update ' + selected_book"
                  >
                    <img 
                      src="@/assets/new-book-update.png" 
                      class="h-5 inline cursor-pointer hover:scale-110 transition-transform"
                    >
                  </a>
                </span>
                <span v-else>{{ selected_book }}</span>
              </p>
              <p v-else-if="vuexLoaderTrigger" class="skeleton-box w-full">&emsp;</p>
              
              <!-- Description (wraps, not hidden) -->
              <p 
                v-if="!vuexLoaderTrigger" 
                class="text-sm text-gray-600 leading-snug"
              >
                {{ selected_book_desc }}
              </p>
              <p v-else-if="vuexLoaderTrigger" class="w-40 skeleton-box">&emsp;</p>
            </div>

            <!-- RIGHT SIDE: Search Controls -->
            <div class="sm:mt-2 mx-2 flex items-center space-x-2 flex-shrink-0">
              <div class="relative w-[300px]">
                <!-- Keyword Search -->
                <input 
                  type="text"  
                  v-model="search_tile" 
                  class="h-8 w-full pr-8 pl-5 rounded-3xl z-0 border border-gray-300 focus:shadow focus:outline-none" 
                  :placeholder="'Search in '+selected_book+'...'"
                  @focus="onSearchInputFocus"
                  @click="onSearchInputClick"
                  @blur="onSearchInputBlur"
                />

                <div
                  v-if="showFrequentTilesSection"
                  class="absolute top-10 left-0 w-full bg-white/10 backdrop-blur-2xl backdrop-saturate-150 border border-white/30 rounded-3xl shadow-[0_8px_32px_rgba(31,38,135,0.2)] z-20 ring-1 ring-inset ring-white/40 overflow-hidden"
                >
                  <!-- Glass sheen highlight -->
                  <div class="pointer-events-none absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/30 to-transparent"></div>

                  <div class="relative px-4 py-2 border-b border-white/20 text-xs font-semibold text-slate-600 text-left tracking-[0.14em] uppercase">
                    Frequently Used
                  </div>
                  <ul v-if="frequentTilesHasItems" class="relative max-h-60 overflow-y-auto py-1 divide-y divide-white/10">
                    <li
                      v-for="(tile, index) in frequentTilesDisplayList"
                      :key="tile.tile_id || index"
                      class="mx-1 px-3 py-2 text-left text-sm text-slate-700 rounded-xl hover:bg-white/40 hover:shadow-[0_1px_6px_rgba(0,0,0,0.12)] cursor-pointer flex items-center justify-between gap-2 transition-all duration-150 leading-tight"
                      @mousedown.prevent
                      @click="onFrequentTileSelect(tile)"
                    >
                      <span class="truncate font-medium flex-1">{{ tile.title }}</span>
                      <button
                        type="button"
                        class="text-slate-400 hover:text-slate-600 px-2 py-1 rounded shrink-0 transition-colors duration-150 flex items-center justify-center"
                        title="Remove from list"
                        aria-label="Remove from list"
                        @mousedown.prevent
                        @click.stop="onFrequentTileRemove(tile)"
                      >
                        <i class="fa-solid fa-trash text-sm leading-none"></i>
                      </button>
                    </li>
                  </ul>
                  <div v-else class="relative px-4 py-3 text-sm text-slate-500 text-left">
                    No frequent tiles yet
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <!-- Main Content -->
        <div class="m-2 flex flex-col h-[100%]">
            <!-- Content -->
            <div class="grid grid-cols-1 grid-cols-6 gap-4 flex-grow">
                <!-- Sidebar -->
                <div class="bg-white rounded-3xl col-span-1 lg:h-65vh" :style="dynamicVH2">
                    <div v-if="!vuexLoaderTrigger">
                      <div v-if="search_tile != '' || semantic_search_query != ''">
                            <p class="text-left font-bold px-4 py-2" v-if="searchElapsedTime == 0">Searching in {{selected_book}}...</p>
                            <p class="text-left font-bold px-4 py-2" v-else>Result in {{selected_book}}...</p>
                            
                            
                      </div>
                      <div v-else-if="search_tile == ''">
                          <p class="text-left font-bold px-4 pt-4 pb-2">Pages</p>
                      </div>
                    </div>

                    <div v-else-if="vuexLoaderTrigger">
                      <p class="w-28 skeleton-box m-6 text-left"></p>
                    </div>

                    <div class="overflow-y-auto " v-if="!vuexLoaderTrigger">
                      <div v-if="search_tile != '' || semantic_search_query != ''" class="p-2">
                        <div v-if="isSemanticSearching && semantic_search_query != ''" >
                          <span>
                            Looking for <br>
                            <span class="font-bold">" {{ semantic_search_query }} "</span>
                          </span> <br>
                          <br>
                          <!-- Modern spinner -->
                          <i class="fas fa-circle-notch fa-spin text-blue-500 text-lg"></i><br><br>
                          
                          <span v-if="processedTiles === 0" class="text-xs italic text-gray-500">
                            Checking your search query...
                          </span>

                          <span v-else>
                            <div>
                              <span>
                                Scanning tiles, please wait...
                              </span>
                              <br>
                              <span class="font-semibold text-blue-600">
                                {{ searchTileCount }} found so far
                              </span>.
                            </div>
                            <div class="text-xs text-gray-500 mt-1">
                              {{ processedTiles }} of {{ totalTiles }} tiles scanned
                            </div>
                          </span>

                          <!-- Stop button -->
                          <button
                            @click="stopProcessingSemanticSearch"
                            class="ml-2 px-2 py-1 bg-red-500 text-white text-xs rounded hover:bg-red-600"
                            v-if="processedTiles != 0"
                          >
                            Stop
                          </button>

                          <br><br>
                          <button v-if="active_tile"
                            @click="backtoSemanticSearchResults"
                            class="ml-2 px-2 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600"
                          >
                            Back to Search Results
                          </button>
                        </div>
                        <div v-else>
                          <div v-if="semanticerrorMessage != ''">
                            <div class="bg-red-100 border border-red-400 text-red-700 px-5 py-8 rounded relative m-5" role="alert">
                              Hmm… 
                              <span class="block sm:inline mt-5">{{ semanticerrorMessage }}</span>
                              <span class="absolute top-0 bottom-0 right-0 px-2 py-3" @click="semanticerrorMessage = ''">
                                <svg class="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
                              </span>
                            </div>
                            <button
                              v-if="semantic_search_query != ''"
                              @click="clearSemanticSearch"
                              class="ml-2 mt-2 mb-4 px-2 py-1 bg-red-500 text-white text-xs rounded hover:bg-red-600"
                            >
                              Clear Search Query
                            </button>
                          </div>
                          <div v-else>
                            Results <span v-if="semantic_search_query != ''">relevant to <br><strong>"{{ semantic_search_query }}"</strong></span><br><br>
                            <strong class="font-semibold text-blue-600">{{searchTileCount}}</strong>
                            <span v-if="searchTileCount <= 1" class="font-semibold text-blue-600"> tile found.</span>
                            <span v-else class="font-semibold text-blue-600"> tiles found.</span> 
                            <br>
                            <span v-if="semantic_search_query != ''" class="text-xs italic text-gray-500 mt-1">
                              {{ processedTiles }} of {{ totalTiles }} tiles scanned
                            </span>
                            <br>
                            <div 
                              class="text-xs italic text-gray-500 mt-1 flex justify-center items-center gap-1" 
                              v-if="searchElapsedTime != 0"
                            >
                              <span>
                                Completed in {{ searchElapsedTime }}
                              </span>
                              <span class="relative inline-flex items-center group">
                                <i class="fas fa-info-circle text-gray-400 cursor-default text-[11px] leading-none"></i>
                                <!-- Tooltip -->
                                <div
                                  class="absolute top-full mt-1 left-1/2 -translate-x-1/2 whitespace-nowrap 
                                        bg-gray-800 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 
                                        transition-opacity duration-200 pointer-events-none"
                                >
                                  ~{{ elapsedPerTile }}s per tile content.
                                </div>
                              </span>
                            </div>


                            <button
                              v-if="semantic_search_query != ''"
                              @click="clearSemanticSearch"
                              class="ml-2 mt-4 px-2 py-2 mb-4 w-40 bg-red-500 text-white text-xs rounded hover:bg-red-600"
                            >
                              Clear Search Results
                            </button>
                            <br>
                            <hr class="mx-6">
                            <div v-if="active_tile && semantic_search_query != ''">
                              <button 
                                @click="backtoSemanticSearchResults"
                                class="ml-2 mt-4 px-2 py-2 w-40 bg-blue-500 text-white text-xs rounded hover:bg-blue-600"
                              >
                                Back to Search Results
                              </button>
                              <br>
                              <button
                                @click="selectThisTileFromSearch"
                                class="ml-2 px-2 mt-1 py-2 w-40 bg-green-500 text-white text-xs rounded hover:bg-green-600"
                              >
                                Go to this Tile
                              </button>
                          </div>
                        </div>
                        
                          
                        </div>
                      </div>
                      <div v-else-if="search_tile == ''">
                        
                        <!-- Sidebar -->
                          <ul class="space-y-2 bg-base-100 p-2 w-full lg:h-55vh overflow-y-auto" id="pageScrollable">
                                <li v-for="(page, index) in active_pages" :key="page.id" :id="'page-' + page.title">
                                    <div v-if="page.tiles">
                                      <button 
                                          @click="toggleSubItems(index, page.title); selectPage(page.title); resetTile()"
                                          class="block bg-gray-100 px-4 py-2 font-bold hover:bg-blue-700 hover:text-white rounded w-full text-left flex items-center"
                                          v-bind:class="{ 'text-blue-600': selected_page === page.title }"
                                      >
                                          <span 
                                            class="mr-2 transition-transform"
                                            v-bind:class="{ 'rotate-90': selected_page === page.title && index === this.openSections }"
                                          >
                                            <i :class="('fa-solid fa-caret-right h-3 inline')"></i>
                                          </span>
                                          <small class="truncate max-w-[150px] inline-block overflow-hidden whitespace-nowrap align-middle" :title="page.title">
                                            {{ page.title }}
                                          </small>
                                      </button>

                                        <ul v-show="isOpen(index)" class="space-y-2 pl-6 border-l border-gray-300 ml-4 mr-2">
                                            <li v-if="!isThereTile" class="px-2 py-1 mt-2 rounded text-left">
                                              No tiles available.
                                            </li>

                                            <li v-else v-for="(tile, subIndex) in page.tiles.filter(tile => !(web_only && tile.is_web_available === 'no'))" 
                                                :key="subIndex" 
                                                class="px-2 pt-2 mt-2 hover:bg-blue-700 hover:text-white hover:cursor-pointer rounded text-left"
                                                v-bind:class="{ 'bg-gray-100 font-bold text-blue-500 ': active_tile && active_tile.title === tile.title }"
                                                v-on:click="tile.is_web_available === 'yes' ? tile_selected(selected_book, tile.id) : this.mobile_only()"
                                                v-bind:id="'tile'+tile.id"
                                                :title="tile.title + (tile.is_web_available === 'no' ? ' (Available on mobile app only)' : '')"
                                            >

                                            <i
                                                v-if="tile.is_web_available == 'yes'"
                                            >
                                              <a class="text-left truncate max-w-[190px] inline-block overflow-hidden whitespace-nowrap"> 
                                                <span>
                                                  <img v-if="tile.icon === 'brands cloudstaff-emblem'" src="@/assets/cloudstaff-emblem.png" class="inline h-4"/> <!-- if current_icon == " brands cloudstaff-emblem "-->
                                        
                                                  <!-- If the icon is airsupply, show the airsupply image -->
                                                  <img v-else-if="tile.icon === 'brands airsupply'" 
                                                              src="@/assets/airsupply-sqr.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands foodpanda'" 
                                                              src="@/assets/foodpanda-sqr.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands oporto'" 
                                                              src="@/assets/oporto-sqr.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands chargrill'" 
                                                              src="@/assets/chargrill.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands chickentreat'" 
                                                              src="@/assets/chickentreat.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands frostyboy'" 
                                                              src="@/assets/frostyboy.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands rappi'" 
                                                              src="@/assets/rappi.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands redrooster'" 
                                                              src="@/assets/redrooster.png" 
                                                              class="inline h-4" />

                                                  <i v-else :class="('fa-'+font_weight+' fa-'+tile.icon+' h-4')"></i></span> <small>{{tile.title}}</small>
                                                <!-- <img :src="baseAPIURL+'/img/icons/'+tile.icon" class="h-4"/> {{tile.title}} -->
                                              </a>
                                            </i>

                                          <i
                                                v-else-if="tile.is_web_available == 'no'"
                                                v-bind:id="'tile'+tile.id">
                                              <a class="text-left truncate max-w-[190px] inline-block overflow-hidden whitespace-nowrap text-gray-400">
                                                <span>
                                                  <img v-if="tile.icon === 'brands cloudstaff-emblem'" src="@/assets/cloudstaff-emblem.png" class="inline h-4"/> <!-- if current_icon == " brands cloudstaff-emblem "-->
                                                  
                                                  <!-- If the icon is airsupply, show the airsupply image -->
                                                  <img v-else-if="tile.icon === 'brands airsupply'" 
                                                              src="@/assets/airsupply-sqr.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands foodpanda'" 
                                                              src="@/assets/foodpanda-sqr.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands oporto'" 
                                                              src="@/assets/oporto-sqr.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands chargrill'" 
                                                              src="@/assets/chargrill.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands chickentreat'" 
                                                              src="@/assets/chickentreat.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands frostyboy'" 
                                                              src="@/assets/frostyboy.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands rappi'" 
                                                              src="@/assets/rappi.png" 
                                                              class="inline h-4" />
                                                  <img v-else-if="tile.icon === 'brands redrooster'" 
                                                              src="@/assets/redrooster.png" 
                                                              class="inline h-4" />

                                                  <i v-else :class="('fa-'+font_weight+' fa-'+tile.icon+' h-4')"></i></span> {{tile.title}}
                                                  <i :class="('fa-solid fa-'+phone_icon+' h-4')" title="Available only in the app."></i>
                                              </a>
                                            </i>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else>
                                        <a href="#" class="block hover:bg-blue-700 rounded">{{ page.title }}</a>
                                    </div>
                                </li>
                          </ul>


                          
                      </div>
                    </div>

                    <div class="" v-else-if="vuexLoaderTrigger">
                      <ul class="menu bg-base-100 menu-compact p-2 w-full  lg:h-55vh" :style="dynamicVH1"  v-if="!active_tile">
                        <li><a class="w-40 skeleton-box m-2">&emsp;</a></li>
                        <li><a class="w-20 skeleton-box m-2">&emsp;</a></li>
                        <li><a class="w-40 skeleton-box m-2">&emsp;</a></li>
                        <li><a class="w-24 skeleton-box m-2">&emsp;</a></li>
                      </ul>

                      <ul class="menu bg-base-100 menu-compact p-2 w-full  lg:h-55vh" id="tileScrollable" v-if="active_tile != null">
                        <li><a class="w-40 skeleton-box m-2">&emsp;</a></li>
                        <li><a class="w-20 skeleton-box m-2">&emsp;</a></li>
                        <li><a class="w-40 skeleton-box m-2">&emsp;</a></li>
                        <li><a class="w-24 skeleton-box m-2">&emsp;</a></li>
                      </ul>
                    </div>

                </div>
                <!-- Main Content [PAGES]-->
                <div class="col-span-5 rounded-3xl blue-card lg:overflow-y-auto lg:h-65vh" :style="dynamicVH2"  v-if="active_tile == null || search_tile != ''" >
                        <div class="flex flex-wrap ">

                          <div class="my-1 px-2 w-full overflow-hidden sm:3/6  md:w-1/6 xl:w-1/6 hover:cursor-pointer rounded-3xl" v-for="tile in showTile[0]" :key="tile.id">
                      
                            <div>
                                  <div class="relative bg-base-100 rounded-box hover:bg-blue-100 pb-10  mb-2 rounded-3xl" v-on:click="tile_selected(selected_book, tile.id)"  
                            v-if="tile.is_web_available == 'yes'">
                                  <div v-if="!vuexLoaderTrigger">
                                            <!-- Favorite star icon (top-left) -->
                                            <div class="absolute top-1 left-1 z-10" @click.stop>
                                                <FavStar 
                                                    :key="selected_book + '-' + tile.id"
                                                    :tile-id="tile.id"
                                                    :initial-starred="favorite_tile_ids.includes(tile.id)"
                                                    :base-url="baseAPIURL"
                                                    :auth-token="$store.getters.auth_token" />
                                            </div>
                                            <div class="flex justify-end" v-if="tiles_complete_clear.some(ele => ele.tile_id === tile.id)">
                                        <span class="
                                                  flex
                                                  justify-end 
                                                  px-2 
                                                  py-1 
                                                  top-0
                                                  text-xs 
                                                  font-bold 
                                                  leading-none 
                                                  text-red-100 
                                                  bg-sky-600 
                                                  rounded-bl-lg
                                                  rounded-tr-xl
                                                  "
                                                  :style="{ 'background-color': '#'+tile.flag_icon_color }"
                                                >
                                        <small>Required </small>
                                        </span>
                                    </div>
                                    <div class="flex justify-end" v-else-if="tiles_open_clear.some(ele => ele.tile_id === tile.id)">
                                        <span class="
                                                  flex
                                                  justify-end 
                                                  px-2 
                                                  py-1 
                                                  top-0
                                                  text-xs 
                                                  font-bold 
                                                  leading-none 
                                                  text-red-100 
                                                  bg-sky-600 
                                                  rounded-bl-lg
                                                  rounded-tr-xl
                                                  "
                                                  :style="{ 'background-color': '#'+tile.flag_icon_color }"
                                                >
                                        <small>Updated </small>
                                        </span>
                                    </div>
                                    <div class="flex justify-end" v-else-if="tiles_update.includes(tile.id)">
                                        <span class="
                                                  flex
                                                  justify-end 
                                                  px-2 
                                                  py-1 
                                                  top-0
                                                  text-xs 
                                                  font-bold 
                                                  leading-none 
                                                  text-red-100 
                                                  bg-sky-600 
                                                  rounded-bl-lg
                                                  rounded-tr-xl
                                                  ">
                                        <small>Updated </small>
                                        </span>
                                    </div>

                                    <div class="flex justify-end" v-else-if="tiles_new.includes(tile.id)">
                                        <span class="
                                                  flex
                                                  justify-end 
                                                  px-2 
                                                  py-1 
                                                  top-0
                                                  text-xs 
                                                  font-bold 
                                                  leading-none 
                                                  text-red-100 
                                                  bg-green-600
                                                  rounded-bl-lg
                                                  rounded-tr-xl
                                                  ">
                                        <small>New </small>
                                        </span>
                                    </div>
                                    <div class="flex justify-end" v-else>
                                        <span class="
                                                  py-2 
                                                ">
                                        <small></small>
                                        </span>
                                    </div>
                                  
                                  </div>
                                  <div v-else-if="vuexLoaderTrigger">
                                    <div class="flex justify-end">
                                        <span class="
                                                  py-4 
                                                ">
                                        <small></small>
                                        </span>
                                    </div>
                                  </div>

                                    <span v-if="!vuexLoaderTrigger" class="mx-auto">
                                      <img v-if="tile.icon === 'brands cloudstaff-emblem'" src="@/assets/cloudstaff-emblem.png" class="inline mt-7 h-10"/> <!-- if current_icon == " brands cloudstaff-emblem "-->
                                      
                                      <!-- If the icon is airsupply, show the airsupply image -->
                                      <img v-else-if="tile.icon === 'brands airsupply'" 
                                                  src="@/assets/airsupply.png" 
                                                  class="inline  mt-7 h-10" />
                                      <img v-else-if="tile.icon === 'brands foodpanda'" 
                                                  src="@/assets/foodpanda.png" 
                                                  class="inline mt-7 h-10" />
                                      <img v-else-if="tile.icon === 'brands oporto'" 
                                                  src="@/assets/oporto.png" 
                                                  class="inline mt-7 h-10" />
                                      <img v-else-if="tile.icon === 'brands chargrill'" 
                                                  src="@/assets/chargrill.png" 
                                                  class="inline mt-7 h-10" />
                                      <img v-else-if="tile.icon === 'brands chickentreat'" 
                                                  src="@/assets/chickentreat.png" 
                                                  class="inline mt-7 h-10" />
                                      <img v-else-if="tile.icon === 'brands frostyboy'" 
                                                  src="@/assets/frostyboy.png" 
                                                  class="inline mt-7 h-10" />
                                      <img v-else-if="tile.icon === 'brands rappi'" 
                                                  src="@/assets/rappi.png" 
                                                  class="inline mt-7 h-10" />
                                      <img v-else-if="tile.icon === 'brands redrooster'" 
                                                  src="@/assets/redrooster.png" 
                                                  class="inline mt-7 h-10" />
                                                  
                                      <i v-else :class="('fa-'+font_weight+' fa-'+tile.icon+' mt-6 h-10')"></i>
                                    </span>
                                    <span v-else-if="vuexLoaderTrigger" class="skeleton-box h-10 w-10"></span>
                                  
                                    <div class="pt-2 text-base flex justify-center">
                                        <p class="text-sm font-bold text-gray-900 opacity-75 py-0 px-3 m-0 truncate overflow-hidden" data-bs-toggle="tooltip" data-bs-placement="top" :title="tile.title" v-if="!vuexLoaderTrigger">
                                          {{tile.title}}
                                        </p>

                                        <p class="skeleton-box w-full mx-6 my-2" v-else-if="vuexLoaderTrigger">
                                          &emsp;
                                        </p>
                                    </div>
                            </div>

                              <div class="bg-gray-100 rounded-box pb-10  mb-2 rounded-3xl" v-on:click="mobile_only()"  
                              v-if="tile.is_web_available == 'no'">
                                  <div v-if="!vuexLoaderTrigger">
                                    <div class="flex justify-end">
                                        <span class="
                                                  flex
                                                  justify-end 
                                                  px-2 
                                                  py-1 
                                                  my-1
                                                  mx-1
                                                  top-0
                                                  "
                                                >
                                        <small>
                                          <i :class="('fa-solid fa-'+phone_icon+' h-4')" title="Available only in the app."></i>
                                        </small>
                                        </span>
                                    </div>
                                  </div>
                                  <div v-else-if="vuexLoaderTrigger">
                                    <div class="flex justify-end">
                                        <span class="
                                                  py-4 
                                                ">
                                        <small></small>
                                        </span>
                                    </div>
                                  </div>
                                    <span v-if="!vuexLoaderTrigger" class="mx-auto mt-0">
                                      <!-- If the icon is cloudstaff-emblem, show the image -->
                                      <img v-if="tile.icon === 'brands cloudstaff-emblem'" 
                                          src="@/assets/cloudstaff-emblem.png" 
                                          class="inline mt-1 h-10" />

                                      <!-- If the icon is airsupply, show the airsupply image -->
                                      <img v-else-if="tile.icon === 'brands airsupply'" 
                                          src="@/assets/airsupply.png" 
                                          class="inline mt-1 h-10" />
                                      <img v-else-if="tile.icon === 'brands foodpanda'" 
                                          src="@/assets/foodpanda.png" 
                                          class="inline mt-1 h-10" />
                                      <img v-else-if="tile.icon === 'brands oporto'" 
                                          src="@/assets/oporto.png" 
                                          class="inline mt-1 h-10" />
                                      <img v-else-if="tile.icon === 'brands chargrill'" 
                                          src="@/assets/chargrill.png" 
                                          class="inline mt-1 h-10" />
                                      <img v-else-if="tile.icon === 'brands chickentreat'" 
                                          src="@/assets/chickentreat.png" 
                                          class="inline mt-1 h-10" />
                                      <img v-else-if="tile.icon === 'brands frostyboy'" 
                                          src="@/assets/frostyboy.png" 
                                          class="inline mt-1 h-10" />
                                      <img v-else-if="tile.icon === 'brands rappi'" 
                                          src="@/assets/rappi.png" 
                                          class="inline mt-1 h-10" />
                                      <img v-else-if="tile.icon === 'brands redrooster'" 
                                          src="@/assets/redrooster.png" 
                                          class="inline mt-1 h-10" />
                                                  

                                      <!-- Otherwise, show the icon -->
                                      <i v-else :class="`fa-${font_weight} fa-${tile.icon} h-10`"></i>
                                    </span>

                                    <span v-else-if="vuexLoaderTrigger" class="skeleton-box h-10 w-10"></span>
                                  
                                    <div class="pt-2 text-base flex justify-center">
                                        <p class="text-sm font-bold text-gray-900 opacity-75 py-0 px-3 m-0 truncate overflow-hidden" data-bs-toggle="tooltip" data-bs-placement="top"  :title="tile.title" v-if="!vuexLoaderTrigger">
                                          {{tile.title}}
                                        </p>
                                        <p class="skeleton-box w-full mx-6 my-2" v-else-if="vuexLoaderTrigger">
                                          &emsp;
                                        </p>
                                    </div>
                            </div>
                            </div>
                          </div>

                          <div v-if="!isThereTile && semantic_search_query == ''" class="p-8">
                                No tiles available.
                          </div>
                        </div>
                </div>

                <!-- Main Content [TILE]-->

                <div class="flex flex-col col-span-5 bg-base-100 px-5 rounded-3xl lg:h-65vh" :style="dynamicVH2" v-if="active_tile != null && search_tile == '' && tile_view_display == 'Default'" >
                    <!-- TILE CONTENT -->
                    <header class="bg-base-100 font-bold text-2xl text-left py-5 px-8 w-full">
                      <!-- <img v-if="!vuexLoaderTrigger" :src="baseAPIURL+'/img/icons/'+this.$store.getters.active_tile.icon" class="inline h-12 mr-2"/> -->

                      <span v-if="!vuexLoaderTrigger" class="inline h-12 mr-2">
                          <span v-if="load_current_icon">
                              <img v-if="current_icon === 'brands cloudstaff-emblem'" src="@/assets/cloudstaff-emblem.png" class="inline h-8"/> <!-- if current_icon == " brands cloudstaff-emblem "-->
                              
                              <!-- If the icon is airsupply, show the airsupply image -->
                              <img v-else-if="current_icon === 'brands airsupply'" 
                                          src="@/assets/airsupply-sqr.png" 
                                          class="inline h-8" />
                              <img v-else-if="current_icon === 'brands foodpanda'" 
                                          src="@/assets/foodpanda-sqr.png" 
                                          class="inline h-8" />
                              <img v-else-if="current_icon === 'brands oporto'" 
                                          src="@/assets/oporto-sqr.png" 
                                          class="inline h-8" />
                              <img v-else-if="current_icon === 'brands chargrill'" 
                                          src="@/assets/chargrill.png" 
                                          class="inline h-8" />
                              <img v-else-if="current_icon === 'brands chickentreat'" 
                                          src="@/assets/chickentreat.png" 
                                          class="inline h-8" />
                              <img v-else-if="current_icon === 'brands frostyboy'" 
                                          src="@/assets/frostyboy.png" 
                                          class="inline h-8" />
                              <img v-else-if="current_icon === 'brands rappi'" 
                                          src="@/assets/rappi.png" 
                                          class="inline h-8" />
                              <img v-else-if="current_icon === 'brands redrooster'" 
                                          src="@/assets/redrooster.png" 
                                          class="inline h-8" />

                              <i v-else :class="('fa-'+font_weight+' fa-'+current_icon+' h-8')"></i> <!-- else "-->
                          </span>
                      </span>
                          
                      <span v-else-if="vuexLoaderTrigger" class="skeleton-box h-10 w-10"></span>

                        <p class="inline" v-if="!vuexLoaderTrigger">
                            {{this.$store.getters.active_tile.title}} 
                            <a v-on:click="reload_tile" title="Reload Tile" class="reload_icon" style="cursor:pointer" v-if="bp_integration.length != 0"  ><img src="@/assets/reload.png" class="inline float-right h-10"/></a>
                            <span style="float: right; margin-right: 8px;">
                                <FavStar
                                    :key="'active-default-' + $store.getters.active_tile.id"
                                    :tile-id="$store.getters.active_tile.id"
                                    :initial-starred="favorite_tile_ids.includes($store.getters.active_tile.id)"
                                    :base-url="baseAPIURL"
                                    :auth-token="$store.getters.auth_token" />
                            </span>
                        </p>
                        
                        <p class="skeleton-box m-4 inline" v-else-if="vuexLoaderTrigger"><span style="padding: 0 80px;"></span></p>
                    </header>
                    <div class="">
                        <div class="w-full border-t border-gray-300"></div>
                    </div>
                    <div class="py-5 px-8 overflow-y-auto overflow-x-hidden text-left lg:h-55vh md:h-50vh" @scroll="onScroll" ref="scrolling" v-if="!vuexLoaderTrigger">
                      <form v-on:change="onChange($event)" id="form_id">
                          <span class="prose dark:prose-dark" v-html="mainFunc(obj.html)"></span>
                          <!-- {{$t(obj.html)}} -->
                          <!-- {{processContent()}} -->
                          
                          <div class="flex items-baseline" v-if="tile_loaded && submittable">
                              <button v-on:click="submit_form" 
                                      class="px-6 py-2 mt-8 text-white bg-blue-600 rounded-lg hover:bg-blue-900 ">
                                      {{this.$store.getters.active_tile.submit_label}}
                              </button>
                          </div>
                        </form>
                    </div>

                    <div class="py-5 px-8 overflow-y-auto overflow-x-hidden text-left lg:h-55vh md:h-50vh" v-else-if="vuexLoaderTrigger">
                      <p class="skeleton-box m-4" ><span style="padding: 0 80px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 60px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 70px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 100px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 120px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 60px;"></span></p><br><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 40px;"></span></p><br>
                    </div>
                </div>

                <div class="flex flex-col col-span-5 bg-base-100 px-5 rounded-3xl lg:h-65vh" :style="dynamicVH2" v-if="active_tile != null && search_tile == '' && tile_view_display == 'Progressive'" >
                    <!-- TILE CONTENT -->
                    <header class="bg-base-100 font-bold text-2xl text-left py-5 px-8 w-full">
                      <!-- <img v-if="!vuexLoaderTrigger" :src="baseAPIURL+'/img/icons/'+this.$store.getters.active_tile.icon" class="inline h-12 mr-2"/> -->

                      <span v-if="!vuexLoaderTrigger" class="inline h-12 mr-2">
                          <span v-if="load_current_icon">
                              <img v-if="current_icon === 'brands cloudstaff-emblem'" src="@/assets/cloudstaff-emblem.png" class="inline h-8"/> <!-- if current_icon == " brands cloudstaff-emblem "-->
                              
                              <!-- If the icon is airsupply, show the airsupply image -->
                              <img v-else-if="current_icon === 'brands airsupply'" 
                                  src="@/assets/airsupply.png" 
                                  class="inline h-8" />
                              <img v-else-if="current_icon === 'brands foodpanda'" 
                                  src="@/assets/foodpanda.png" 
                                  class="inline h-8" />
                              <img v-else-if="current_icon === 'brands oporto'" 
                                  src="@/assets/oporto.png" 
                                  class="inline h-8" />
                              <img v-else-if="current_icon === 'brands chargrill'" 
                                  src="@/assets/chargrill.png" 
                                  class="inline h-8" />
                              <img v-else-if="current_icon === 'brands chickentreat'" 
                                  src="@/assets/chickentreat.png" 
                                  class="inline h-8" />
                              <img v-else-if="current_icon === 'brands frostyboy'" 
                                  src="@/assets/frostyboy.png" 
                                  class="inline h-8" />
                              <img v-else-if="current_icon === 'brands rappi'" 
                                  src="@/assets/rappi.png" 
                                  class="inline h-8" />
                              <img v-else-if="current_icon === 'brands redrooster'" 
                                  src="@/assets/redrooster.png" 
                                  class="inline h-8" />

                              <i v-else :class="('fa-'+font_weight+' fa-'+current_icon+' h-8')"></i>
                          </span>
                      </span>
                          
                      <span v-else-if="vuexLoaderTrigger" class="skeleton-box h-10 w-10"></span>

                        <p class="inline" v-if="!vuexLoaderTrigger">
                            {{this.$store.getters.active_tile.title}}
                          
                          <a href="#" class="copy-link" data-tooltip="Copy link" style="float: right" @click.prevent="copyTileUrl($store.getters.active_tile.uuid || $store.getters.active_tile.id)">
                            <i class="fa-solid fa-link"></i>
                          </a>
                          <span style="float: right; margin-right: 8px;">
                              <FavStar
                                  :key="'active-progressive-' + $store.getters.active_tile.id"
                                  :tile-id="$store.getters.active_tile.id"
                                  :initial-starred="favorite_tile_ids.includes($store.getters.active_tile.id)"
                                  :base-url="baseAPIURL"
                                  :auth-token="$store.getters.auth_token" />
                          </span>

                            <a v-on:click="reload_tile" title="Reload Tile" class="reload_icon" style="cursor:pointer" v-if="bp_integration.length != 0"  ><img src="@/assets/reload.png" class="inline float-right h-10"/></a>
                        </p>
                        <p class="skeleton-box m-4 inline" v-else-if="vuexLoaderTrigger"><span style="padding: 0 80px;"></span></p>
                    </header>
                    <div class="mb-2">
                        <div class="w-full border-t border-gray-300"></div>
                    </div>

                    <div id="tile_content_div" class="flex-grow px-4 flex flex-col overflow-y-auto overflow-x-hidden text-left h-screen" @scroll="onScroll" ref="scrolling" v-if="!vuexLoaderTrigger">
                      <form v-on:change="progressive_onChange($event)" id="form_id">
                          <span class="prose dark:prose-dark " v-html="mainFunc(obj.html)"></span>
                        </form>
                    </div>

                    <div class="flex-grow flex flex-col overflow-y-auto overflow-x-hidden text-left h-screen" v-else-if="vuexLoaderTrigger">
                      <p class="skeleton-box m-4" ><span style="padding: 0 80px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 60px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 70px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 100px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 120px;"></span></p><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 60px;"></span></p><br><br>
                      <p class="skeleton-box m-4" ><span style="padding: 0 40px;"></span></p><br>
                    </div>

                    <!-- Footer -->
                    
                    <div class="flex justify-between items-center mb-4 mt-4" v-if="this.tile_loaded == true">
                      <!-- Previous Button -->
                      <button class="bg-blue-400 hover:bg-blue-900 text-white font-bold py-2 px-4 rounded-lg" v-on:click="prev_page" v-if="currentPage > 1">
                        Previous
                      </button>

                      <!-- Pagination Bullets -->
                      <div class="flex items-center space-x-2 flex-grow justify-center">
                        <div class="pagination">
                          <button v-for="page in totalpages" :key="page" :class="{ active: currentPage === page }" :id="`bullet${page}`">
                            <!-- {{ page }} -->
                          </button>
                        </div>
                      </div>

                      <!-- Next Button -->
                      <button class="bg-blue-400 hover:bg-blue-900 text-white font-bold py-2 px-4 rounded-lg" v-on:click="next_page" >
                        {{nextbtn}}
                      </button>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>
</template>


<script src="../dash.js"></script>
